




















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import ElTableDraggable from 'element-ui-el-table-draggable';
import { UserTypes } from '@/enums/userTypes';
import moment from 'moment';
import Axios from 'axios';
import { ElForm } from 'node_modules/element-ui/types/form';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { PaypalTokenResponse } from '@/models/paypalTokenResponse';
import { PaypalCreateOrderRequest } from '@/models/paypalCreateOrderRequest';
import { PaypalCreateOrderResponse } from '@/models/paypalCreateOrderResponse';
import { PaypalAuthorizeOrderRequest } from '@/models/paypalAuthorizeOrderRequest';
import { PaypalResponse, PaypalCreditcard } from '@/models/paypalResponse';
import { PaypalCreateBillingAgreementRequest } from '@/models/paypalCreateBillingAgreementRequest';
import { PaypalCreateBillingAgreementResponse } from '@/models/paypalCreateBillingAgreementResponse';
import { PaypalFinalizeBillingAgreementRequest } from '@/models/paypalFinalizeBillingAgreementRequest';

interface CreditcardEdit extends PaypalCreditcard {
  isEdit: boolean;
}

@Component({
  components: {
    ElTableDraggable,
  }
})
export default class extends AvaivaledVue {
  @Prop({ required: true })
  public loading!: boolean;

  private get studentId(): string { return this.$route.params.studentId; }
  private get student() { return this.$store.state.student.selectedStudent; }

  private isRegisterd: boolean = false;
  private creditcard: PaypalCreditcard | null = null;

  get localLoading() {
    return this.loading;
  }
  set localLoading(value: boolean) {
    this.$emit('update:loading', value);
  }

  private paypalAccessToken = '';

  private paypalForm: any = null;

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isStudent(): boolean {
    return this.userRole === UserTypes.Student;
  }

  get paypalTokenApiUrl(): string {
    return this.isStudent ? `/api/paypal/token` : `/api/paypal/${this.studentId}/token`;
  }

  get paypalInfoApiUrl(): string {
    return this.isStudent ? `/api/paypal` : `/api/paypal/${this.studentId}`;
  }

  get paypalCreateOrderApiUrl(): string {
    return this.isStudent ? `/api/paypal/create-order` : `/api/paypal/${this.studentId}/create-order`;
  }

  get paypalAuthorizeOrderApiUrl(): string {
    return this.isStudent ? `/api/paypal/authorize-order` : `/api/paypal/${this.studentId}/authorize-order`;
  }

  get paypalCreditcardApiUrl(): string {
    return this.isStudent ? `/api/paypal/creditcard` : `/api/paypal/${this.studentId}/creditcard`;
  }

  get paypalCreateBillingAgreementApiUrl(): string {
    return this.isStudent
      ? `/api/paypal/create-billing-agreement`
      : `/api/paypal/${this.studentId}/create-billing-agreement`;
  }

  get paypalFinalizeBillingAgreementApiUrl(): string {
    return this.isStudent
      ? `/api/paypal/finalize-billing-agreement`
      : `/api/paypal/${this.studentId}/finalize-billing-agreement`;
  }

  get paypalCancelBillingAgreementApiUrl(): string {
    return this.isStudent
      ? `/api/paypal/billing-agreement`
      : `/api/paypal/${this.studentId}/billing-agreement`;
  }

  private created() {
    this.localLoading = true;
  }

  private async mounted() {
    const response = await Axios.get<PaypalTokenResponse>(this.paypalTokenApiUrl);
    const clientId = response.data.clientId;
    this.paypalAccessToken = response.data.accessToken;
    const clientToken = response.data.clientToken;

    await this.loadData();
    this.localLoading = false;

    this.loadPaypalButton(clientId, clientToken);
  }

  private async loadData() {
    try {
      const res = await Axios.get<PaypalResponse>(this.paypalInfoApiUrl);
      const data = res.data;

      this.isRegisterd = data.isPaypalRegisterd;

      if (data.isPaypalRegisterd) {
        if (data.isCreditcard) {
          this.creditcard = {
            cardId: data.creditcard.cardId,
            number: data.creditcard.number,
            expireMonth: data.creditcard.expireMonth,
            expireYear: data.creditcard.expireYear,
          };
        } else {
          this.creditcard = null;
        }
      } else {
        this.creditcard = null;
      }
    } catch (error) {
      this.$router.push({ name: 'Top' });
      return;
    }
  }

  private loadPaypalButton(clientId: string, clientToken: string) {
    this.$nextTick(async () => {
      const script: any = document.createElement('script');
      script.setAttribute(
        'src',
        `https://www.paypal.com/sdk/js?components=hosted-fields&client-id=${
          clientId
        }&currency=JPY&intent=authorize`
      );
      script.setAttribute('data-client-token', clientToken);
      script.setAttribute('type', 'text/javascript');

      await this.loadScript(script);

      const paypalCreditcard = (window as any).paypal;
      (window as any).paypalCreditcard = paypalCreditcard;

      const script2: any = document.createElement('script');
      script2.setAttribute(
        'src',
        `https://www.paypal.com/sdk/js?client-id=${
          clientId
        }&locale=ja_JP&disable-funding=card&intent=tokenize&vault=true`
      );
      script2.setAttribute('type', 'text/javascript');

      await this.loadScript(script2);

      this.renderPaypalButton();
    });
  }

  private loadScript(script: any): Promise<void> {
    const head = document.getElementsByTagName('head')[0];
    return new Promise((resolve) => {
      let done = false;
      script.onload = script.onreadystatechange = function() {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          done = true;
          script.onload = script.onreadystatechange = null;
          head.removeChild( script );

          resolve();
        }
      };
      head.appendChild(script);
    });
  }

  private renderPaypalButton() {
    const paypal = (window as any).paypal;
    if (paypal) {
      if (document.querySelector('#paypal-button-container')) {
        paypal.Buttons({
          createBillingAgreement: async () => {
            try {
              const request: PaypalCreateBillingAgreementRequest = {
                token: this.paypalAccessToken,
              };
              const response = await Axios.post<PaypalCreateBillingAgreementResponse>(
                this.paypalCreateBillingAgreementApiUrl, request
              );
              return response.data.tokenId;
            } catch (error) {
              await this.loadData();
              this.localLoading = false;

              this.$notify.error({
                title: 'PAYPAL決済',
                message: 'PAYPAL決済の承認中にエラーが発生しました。再度お試しください。',
                position: 'bottom-right'
              });
            }
          },
          onApprove: async (data: any) => {
            try {
              const request: PaypalFinalizeBillingAgreementRequest = {
                accessToken: this.paypalAccessToken,
                billingToken: data.billingToken,
              };
              await Axios.post(this.paypalFinalizeBillingAgreementApiUrl, request);

              await this.loadData();
              this.localLoading = false;

              this.$notify.success({
                title: 'PAYPAL決済',
                message: 'PAYPAL決済が承認されました',
                position: 'bottom-right'
              });
            } catch (error) {
              await this.loadData();
              this.localLoading = false;

              this.$notify.error({
                title: 'PAYPAL決済',
                message: 'PAYPAL決済の承認中にエラーが発生しました。再度お試しください。',
                position: 'bottom-right'
              });
            }
          }
        }).render('#paypal-button-container');
      }
    }
  }

  private async onAdd() {
    const form: CreditcardEdit = {
      isEdit: false,
      cardId: '',
      number: '',
      expireMonth: '',
      expireYear: '',
    };

    try {
      this.renderCreditcardForm();
      await (this.$refs.cardEdit as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }
  }

  private async onEdit() {
    if (!this.creditcard) {
      return;
    }

    const form: CreditcardEdit = {
      isEdit: true,
      cardId: this.creditcard.cardId,
      number: this.creditcard.number,
      expireMonth: this.creditcard.expireMonth,
      expireYear: this.creditcard.expireYear,
    };

    try {
      this.renderCreditcardForm();
      await (this.$refs.cardEdit as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }
  }

  private async onDelete() {
    try {
      await this.$confirm('クレジットカードを削除します。よろしいですか？', 'クレジットカード削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    this.localLoading = true;

    try {
      await Axios.delete(this.paypalCreditcardApiUrl, {
        dontDisplayErrorPage: true,
      });
      this.$notify.success({
        title: 'クレジットカード削除',
        message: 'クレジットカード情報を削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード削除',
        message: 'クレジットカード情報の削除が失敗しました。',
        position: 'bottom-right'
      });
    }

    await this.loadData();
    this.localLoading = false;

    this.$nextTick(() => {
      this.renderPaypalButton();
    });
}

  private async onCancelPaypal() {
    try {
      await this.$confirm('PAYPAL決済を削除ます。よろしいですか？', 'PAYPAL決済削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    this.localLoading = true;

    try {
      await Axios.delete(this.paypalCancelBillingAgreementApiUrl, {
        dontDisplayErrorPage: true,
      });
      this.$notify.success({
        title: 'PAYPAL決済削除',
        message: 'PAYPAL決済を削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'PAYPAL決済削除',
        message: 'PAYPAL決済の削除が失敗しました。',
        position: 'bottom-right'
      });
    }

    await this.loadData();
    this.localLoading = false;

    this.$nextTick(() => {
      this.renderPaypalButton();
    });
  }

  private renderCreditcardForm() {
    const paypal = (window as any).paypalCreditcard;
    if (paypal.HostedFields.isEligible()) {
      paypal.HostedFields.render({
        createOrder: async (data: any, actions: any) => {
          try {
            const request: PaypalCreateOrderRequest = {
              token: this.paypalAccessToken,
            };
            const response = await Axios.post<PaypalCreateOrderResponse>(this.paypalCreateOrderApiUrl, request);
            return response.data.orderId;
          } catch (error) {
            await this.loadData();
            this.localLoading = false;

            (this.$refs.cardEdit as DialogWrapper).submit();

            this.$notify.error({
              title: `クレジットカード登録`,
              message: `クレジットカード登録処理中にエラーが発生しました。クレジットカード情報の入力をお確かめください。`,
              position: 'bottom-right'
            });
          }
        },
        styles: {
          'input': {
            'font-size': '14px',
            'font-family': 'Product Sans',
            'color': '#3a3a3a',
          },
          ':focus': {
            color: 'black',
          },
          '.invalid': {
            color: '#FF0000',
          },
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: 'カード番号',
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YYYY',
          },
          cvv: {
            selector: '#cvv',
            placeholder: 'CVV',
          },
        }
      }).then((hf: any) => {
        this.paypalForm = hf;
      });
    }

  }

  private submitForm(isEdit: boolean) {
    this.localLoading = true;

    const modeText = isEdit ? '変更' : '登録';
    (this.$refs.form as ElForm).validate(async (valid) => {
      if (valid) {
        this.paypalForm.submit({ vault: true }).then(async (payload: PaypalCreateOrderResponse) => {
          try {
            const request: PaypalAuthorizeOrderRequest = {
              token: this.paypalAccessToken,
              orderId: payload.orderId,
              currentCardId: isEdit ? this.creditcard!.cardId : null,
            };
            await Axios.post(this.paypalAuthorizeOrderApiUrl, request);

            await this.loadData();
            this.localLoading = false;

            (this.$refs.cardEdit as DialogWrapper).submit();

            this.$notify.success({
              title: `クレジットカード${modeText}`,
              message: `クレジットカード情報を${modeText}しました。`,
              position: 'bottom-right'
            });
          } catch (error) {
            await this.loadData();
            this.localLoading = false;

            (this.$refs.cardEdit as DialogWrapper).submit();

            this.$notify.error({
              title: `クレジットカード${modeText}`,
              message: `クレジットカード${modeText}処理中にエラーが発生しました。クレジットカード情報の入力をお確かめください。`,
              position: 'bottom-right'
            });
          }
        });
      } else {
        this.$notify.error({
          title: `クレジットカード${modeText}`,
          message: `クレジットカード${modeText}処理中にエラーが発生しました。クレジットカード情報の入力をお確かめください。`,
          position: 'bottom-right'
        });
        this.localLoading = false;
      }
    });
  }
}
